module.exports = __webpack_public_path__ + "static/img/eyes_06.d98d673.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_06.png
// module id = veg1
// module chunks = 0